export const fmtCurrency = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(Number(n || 0));

/**
 * Türkiye saatiyle bugünün 'YYYY-MM-DD' formatı.
 * UTC yerine Europe/Istanbul (UTC+3) kullanır — Türkiye 00:00-03:00 arası
 * varsayılan tarih bir gün geri kaymaz. Pazar/hafta günü tespiti de bu yolla
 * doğru gün üzerinden yapılır.
 */
export const getTrToday = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Istanbul" });

export const fmtNumber = (n) =>
  new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(n || 0));

/**
 * Saat,dakika formatı: 3.5 → "3,30", 3.25 → "3,15", 0.5 → "0,30".
 * Girdiyi mutlak değerle işler; negatif değerler "-" prefix ile döner.
 * Dakika 60'a yuvarlanırsa saat +1, dakika 0 olarak taşırılır.
 */
export const fmtHM = (hours) => {
  const num = Number(hours || 0);
  if (!Number.isFinite(num)) return "0,00";
  const sign = num < 0 ? "-" : "";
  const abs = Math.abs(num);
  let h = Math.floor(abs + 1e-9);
  let m = Math.round((abs - h) * 60);
  if (m >= 60) { h += 1; m = 0; }
  return `${sign}${h},${String(m).padStart(2, "0")}`;
};

/**
 * Dakika → 'H,MM' formatı (5 saat 10 dakika → "5,10").
 * Puantaj sütunlarında kullanılır; kaynak veri backend'de dakika cinsinden gelir.
 */
export const fmtMinsHM = (mins) => {
  const n = Number(mins || 0);
  if (!Number.isFinite(n)) return "0,00";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Math.round(n));
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  return `${sign}${h},${String(m).padStart(2, "0")}`;
};

export const quotePdfName = (q) =>
  `${[q.quote_number || "teklif", (q.customer_name || "").trim()].filter(Boolean).join(" - ").replace(/[\\/:*?"<>|]+/g, " ").trim()}.pdf`;

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

/**
 * ISO tarihi "YYYY-MM-DD Gün" formatında döner (ör. "2026-09-10 Çarşamba").
 * Timezone kaymasını önlemek için tarih parçaları elle parse edilir; sadece
 * gün adı için Türkiye lokali kullanılır.
 */
export const fmtDateWithDay = (iso) => {
  if (!iso || typeof iso !== "string") return iso || "-";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  const dt = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (Number.isNaN(dt.getTime())) return iso;
  const TR_MONTHS_SHORT = ["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"];
  const TR_DAYS_SHORT = ["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"]; // JS Sunday=0
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${dd} ${TR_MONTHS_SHORT[dt.getMonth()]} ${dt.getFullYear()} ${TR_DAYS_SHORT[dt.getDay()]}`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const ROLE_TR = {
  admin: "Yönetici",
  sub_admin: "Alt Yönetici",
  sales: "Satış",
  warehouse: "Depo",
  production: "Üretim",
  accounting: "Muhasebe",
  hse: "İSG Personeli",
};

export const STATUS_TR = {
  draft: "Taslak",
  sent: "Gönderildi",
  approved: "Onaylandı",
  rejected: "Reddedildi",
  converted: "Siparişe Dönüştü",
  in_progress: "İşlemde",
  completed: "Tamamlandı",
  pending: "Bekliyor",
  ready: "Hazır",
  shipped: "Sevk Edildi",
  cancelled: "İptal Edildi",
  partially_cancelled: "Kısmi İptal",
};
